
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
import { Saica } from "@/types/saica.type";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import SaicaFormComponent from "@/components/saica/SaicaForm.component.vue";
import SaicaListComponent from "@/components/saica/SaicaList.component.vue";
import { errorHandlerDefault } from "@/utils/handler.util";

export default defineComponent({
  components: {
    PageButtonsComponent,
    SaicaFormComponent,
    SaicaListComponent,
  },
  data() {
    return {
      showMap: false,
      showSaicaForm: false,
      saicaForm: undefined as undefined | Saica,
    };
  },
  methods: {
    openSaicaFormDialog() {
      this.showSaicaForm = true;
    },
    closeSaicaFormDialog() {
      this.showSaicaForm = false;
    },
    async saveSaicaForm() {
      await (this.$refs["saicaForm"] as InstanceType<typeof SaicaFormComponent>)
        .doSave()
        ?.then(() => {
          // - close dialog and refresh
          this.closeSaicaFormDialog();
          (this.$refs["saicaList"] as InstanceType<typeof SaicaListComponent>).refreshItems();
          ElMessage.success(this.$t("success.action"));
        })
        .catch(errorHandlerDefault);
    },
  },
});
